module.exports = __webpack_public_path__ + "img/starcraft-remastered.b50f8780.svg";